import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';

export default class CentralMappingOrganizationSettingsAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;

  // @ts-expect-error: Property 'buildURL' in type is not assignable to the same property in base type.
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot<unknown>,
    requestType: string,
    query?: Record<string, unknown>,
  ): string {
    // @ts-expect-error: Expected 3 arguments, but got 5.
    const baseUrl = super.buildURL(modelName, id, snapshot, requestType, query);

    const url = new URL(baseUrl, this.host);
    const { market } = this.hotelAndMarketService;
    if (market) {
      url.searchParams.set('market_id', market.id!);
    }

    return url.toString();
  }

  // Prevent 'organization-settings' → 'organization-settingss' pluralisation
  pathForType(): string {
    return 'mapping/settings';
  }

  urlForUpdateRecord(): string {
    return '/apigateway/v1/app/mapping/settings';
  }
}
